import type { FC } from "react";
import { useCallback, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../hooks/authProvider/authProvider";
import { DropdownMenuItemUI } from "./DropdownMenuItem";

export type DropdownMenuUIProps = {
  visibility: boolean;
  onHidden: () => void;
};

export const DropdownMenuUI: FC<DropdownMenuUIProps> = ({
  visibility,
  onHidden,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const { signOut } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onHidden();
      }
    },
    [onHidden],
  );

  useEffect(() => {
    if (visibility) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [visibility, handleClickOutside]);
  const logout = async () => {
    await signOut();
    navigate("/login");
  };
  if (!visibility) {
    return <></>;
  }
  return (
    <div
      ref={ref}
      className="absolute bottom-full left-0 mb-2 w-48 text-sm bg-white border border-gray-200 rounded-lg shadow-lg z-50"
    >
      <ul className="py-1">
        <DropdownMenuItemUI to={"/profile"}>
          プロフィール設定
        </DropdownMenuItemUI>
        <DropdownMenuItemUI to={"/settings"}>設定</DropdownMenuItemUI>
        <li className="border-t border-gray-200 my-1"></li>
        <DropdownMenuItemUI onClick={logout}>ログアウト</DropdownMenuItemUI>
      </ul>
    </div>
  );
};
